import { BrgButton, FlexBox, MEDIA } from '@brg/ui';
import styled from 'styled-components';

export const Wrapper = styled(FlexBox)`
  max-width: 1152px;
  width: 100%;
  align-items: start;
  flex-direction: column;
  text-align: center;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 64px 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
  gap: 24px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${MEDIA.TABLET} {
    padding: 48px 10px;
  }

  @media ${MEDIA.MOBILE} {
    padding: 24px;
  }
`;

export const Container = styled(FlexBox)`
  width: 100%;
  padding: 32px 40px;
  background: #F2F2F2;
  flex-direction: column;
  align-items: start;
  text-align: start;
  gap: 0;

  @media ${MEDIA.LAPTOP} {
    padding: 24px 32px;
  }

  @media ${MEDIA.TABLET} {
    padding: 24px;
  }

  @media ${MEDIA.MOBILE} {
    padding: 16px;
  }
`;

export const ActionsRow = styled(FlexBox)`
  width: 100%;
  margin-top: 40px;
  flex-shrink: 0;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  align-self: flex-end;

  @media ${MEDIA.LAPTOP} {
    margin-top: 32px;
  }

  @media ${MEDIA.MOBILE} {
    flex-direction: column;
    align-items: stretch;
    align-self: stretch;
  }
`;

export const StyledActionButton = styled(BrgButton)`
  min-width: 200px;

  @media ${MEDIA.MOBILE} {
    width: 100%;
    min-width: unset;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const Title = styled.div`
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.46px;

  @media ${MEDIA.LAPTOP} {
    font-size: 22px;
    line-height: 26px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 21px;
    line-height: 25px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const ContentTitle = styled.div`
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.46px;
  margin-bottom: 8px;

  @media ${MEDIA.LAPTOP} {
    font-size: 22px;
    line-height: 26px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 21px;
    line-height: 25px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const ContentDesc = styled.div`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;

  @media ${MEDIA.LAPTOP} {
    font-size: 16px;
    line-height: 21px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 16px;
    line-height: 21px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const ContentDescSecondary = styled.div`
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #909090;
  margin-top: 8px;
  white-space: pre-line;

  @media ${MEDIA.LAPTOP} {
    font-size: 14px;
    line-height: 18px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 13px;
    line-height: 17px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const ProjectsSection = styled(FlexBox)`
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
  gap: 24px;
`;

export const SectionHeading = styled.div`
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.46px;
  color: #151514;

  @media ${MEDIA.LAPTOP} {
    font-size: 22px;
    line-height: 26px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 21px;
    line-height: 25px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;
import { BrgButton, FlexBox, MEDIA } from '@brg/ui';
import styled from 'styled-components';

export const Wrapper = styled(FlexBox)`
  max-width: 1152px;
  width: 100%;
  align-items: start;
  flex-direction: column;
  text-align: center;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 64px 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
  gap: 24px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${MEDIA.TABLET} {
    padding: 48px 10px;
  }

  @media ${MEDIA.MOBILE} {
    padding: 24px;
  }
`;

export const Container = styled(FlexBox)`
  width: 100%;
  padding: 32px 40px;
  background: #F2F2F2;
  flex-direction: column;
  align-items: start;
  text-align: start;
  gap: 0;

  @media ${MEDIA.LAPTOP} {
    padding: 24px 32px;
  }

  @media ${MEDIA.TABLET} {
    padding: 24px;
  }

  @media ${MEDIA.MOBILE} {
    padding: 16px;
  }
`;

export const ActionsRow = styled(FlexBox)`
  width: 100%;
  margin-top: 40px;
  flex-shrink: 0;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  align-self: flex-end;

  @media ${MEDIA.LAPTOP} {
    margin-top: 32px;
  }

  @media ${MEDIA.MOBILE} {
    flex-direction: column;
    align-items: stretch;
    align-self: stretch;
  }
`;

export const StyledActionButton = styled(BrgButton)`
  min-width: 200px;

  @media ${MEDIA.MOBILE} {
    width: 100%;
    min-width: unset;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const Title = styled.div`
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.46px;

  @media ${MEDIA.LAPTOP} {
    font-size: 22px;
    line-height: 26px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 21px;
    line-height: 25px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const ContentTitle = styled.div`
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.46px;
  margin-bottom: 8px;

  @media ${MEDIA.LAPTOP} {
    font-size: 22px;
    line-height: 26px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 21px;
    line-height: 25px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const ContentDesc = styled.div`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;

  @media ${MEDIA.LAPTOP} {
    font-size: 16px;
    line-height: 21px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 16px;
    line-height: 21px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const ContentDescSecondary = styled.div`
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #909090;
  margin-top: 8px;
  white-space: pre-line;

  @media ${MEDIA.LAPTOP} {
    font-size: 14px;
    line-height: 18px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 13px;
    line-height: 17px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const ProjectsSection = styled(FlexBox)`
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
  gap: 24px;
`;

export const SectionHeading = styled.div`
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.46px;
  color: #151514;

  @media ${MEDIA.LAPTOP} {
    font-size: 22px;
    line-height: 26px;
  }

  @media ${MEDIA.TABLET} {
    font-size: 21px;
    line-height: 25px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;
